// extracted by mini-css-extract-plugin
module.exports = {"root":"StoreLocatorAssistenza_root__aVckC","rotation":"StoreLocatorAssistenza_rotation__fEqeN"};